module.exports = __webpack_public_path__ + "static/media/asterisk.c750c77c.svg";